import TooltipContainer from './ColorTooltip.styles';

export const ColorTooltip = () => (
  <TooltipContainer>Pas hier de kleur aan</TooltipContainer>
);
